<template>
  <v-row>
    <v-col cols="12" class="text-center">
      <h2>Assign Receivers</h2>
    </v-col>
    <v-col cols="10" style="margin-left: 8.3333333333%">
      <v-simple-table fixed-header v-if="addedReceivers.length > 0">
        <template v-slot:default>
          <thead>
            <tr>
              <th><v-checkbox @click="toggleAll()" v-model="checkedAllValue"></v-checkbox></th>
              <th class="text-left">User</th>
              <th class="text-left">Office</th>
              <th class="text-left">
                Action
                <v-btn
                  class="ml-3"
                  small
                  depressed
                  color="primary"
                  @click="addAllInstruction()"
                  :disabled="disable"
                >
                  Add All Action
                </v-btn>
              </th>
              <th>Instructions</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(receiver, idx) in addedReceivers" :key="receiver.index">
              <td>
                <v-checkbox
                  name="checkbox_test"
                  @click="handleClick(idx, receiver)"
                ></v-checkbox>
              </td>
              <td>
                {{
                  `${receiver.user.first_name} ${receiver.user.middle_name} ${receiver.user.last_name}`
                }}
                <!-- {{
                  receiver.user.name
                    ? receiver.user.name
                    : `${receiver.user.first_name} ${receiver.user.last_name}`
                }} -->
              </td>
              <td>{{ getAssignedOffice(receiver) }}</td>
              <td>
                <span v-if="receiver.action">
                  {{ receiver.action.name }}
                  {{
                    receiver.hasActionDueDate
                      ? ' - ' + formatDate(receiver.datetime_due)
                      : ''
                  }}
                  <v-btn icon @click="update(receiver)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </span>
                <span v-else>
                  <v-btn
                    small
                    depressed
                    color="primary"
                    @click="update(receiver)"
                  >
                    Add Action
                  </v-btn>
                </span>
              </td>
              <!-- <td>{{receiver.instructions ? getStringfromHtml(receiver.instructions) : "No instructions included"}}</td> -->
              <td
                v-dompurify-html="
                  receiver.instructions
                    ? getStringfromHtml(receiver.instructions)
                    : `No instructions included`
                "
              ></td>
              <td>
                <!-- <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click="addInstructions(receiver)">
                      <v-icon>mdi-format-list-checks</v-icon>
                    </v-btn>
                  </template>
                  <span>Add Instructions</span>
                </v-tooltip> -->
                <!-- <v-btn icon @click="update(receiver)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn> -->
                <v-btn icon @click="remove(receiver)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    <v-col cols="12" class="text-center">
      <v-btn class="mx-2" fab dark color="indigo" @click="openReceiverModal()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <AddReceiverModal
        :dialog="receiver_dialog"
        :updateReceiver="selected_receiver"
        :isUpdate="select_update"
        :initiatorDueDate="datetime_due"
        @closeDialog="closeReceiverDialog"
        :accessFrom="'mainroute'"
      />
      <AddReceiversAction
        :dialog="receivers_action_dialog"
        :allReceivers="all_receivers"
        :initiatorDueDate="datetime_due"
        @closeDialog="closeReceiverActionDialog"
      />
      <AddReceiverInstructions
        :dialog="instructions_dialog"
        :receiver="selected_receiver"
        @closeDialog="closeReceiverDialog"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AddReceiverModal from './AddReceiverModal';
import AddReceiversAction from './AddAllReceiversModal.vue';
import AddReceiverInstructions from './AddReceiverInstructions';
import moment from 'moment';
import Swal from 'sweetalert2';

export default {
  name: 'AssignReceiversModal',
  props: {
    initiatorDueDate: String,
    showSelect: String,
  },
  components: {
    AddReceiverModal,
    AddReceiverInstructions,
    AddReceiversAction,
  },
  data() {
    return {
      items: [0],
      disable: true,
      receiver_dialog: false,
      receivers_action_dialog: false,
      all_receivers: null,
      selected_receivers: [],
      selected_receiver: null,
      select_update: false,
      instructions_dialog: false,
      datetime_due: this.initiatorDueDate,
      selected: [],
      isDelete: false,
      selected_idx: [],
      selected_all: false,
      checkedAll: false,
      checkedAllValue: false,
    };
  },
  methods: {
    ...mapActions([
      'addUser',
      'removeReceiver',
      'fetchUsers',
      'fetchActions',
      'fetchUsersInOffice',
    ]),
    toggleAll() {
      var checkboxes = document.getElementsByName('checkbox_test');
      for (var checkbox of checkboxes) {
        if (!checkbox.checked) {
          checkbox.click();
        }
      }

      this.checkedAll = true;
    },
    selectedIdx(idx) {
      this.selected_idx.push(idx);
      console.log(this.selected_idx);
    },
    add(user) {
      this.addUser(user);
    },
    handleClick(i, receiver) {
      if (this.checkedAll) {this.checkedAll = false;this.checkedAllValue = false}
      if (!this.isDelete) {
        let pos = this.selected.indexOf(i);
        if (pos > -1) {
          this.selected.splice(pos, 1);
          this.selected_receivers.splice(pos, 1);
        } else {
          this.selected.push(i);
          this.selected_receivers.push(receiver);
        }
        this.all_receivers = this.selected_receivers;
        console.log(this.all_receivers);
        if (this.selected_receivers.length == 0) this.disable = true;
        else this.disable = false;
      }
    },
    getStringfromHtml(html) {
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    getAssignedOffice(receiver) {
      let office_name = '';
      this.allUsersByOffice.forEach((element) => {
        if (element.user_id == receiver.user.id) {
          office_name = element.name;
        }
      });
      return office_name;
    },
    addAllInstruction() {
      this.receivers_action_dialog = true;
    },
    update(receiver) {
      console.log(receiver);
      this.selected = [];
      this.selected_receivers = [];
      this.disable = true;
      this.selected_receiver = receiver;
      this.select_update = true;
      this.receiver_dialog = true;
    },
    remove(receiver) {
      this.isDelete = true;
      Swal.fire({
        title: 'Confirm Action',
        text: `Delete receiver?`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '##1A76D2',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isDismissed) {
          this.isDelete = false;
        }
        if (result.isConfirmed) {
          this.removeReceiver(receiver);
          this.selected = [];
          this.selected_receivers = [];
          this.isDelete = false;
          Swal.fire('Done!', 'Receiver has been deleted.', 'success');
        }
      });
    },
    addReceiver(len) {
      this.items.push(len);
    },
    closeReceiverActionDialog() {
      this.receivers_action_dialog = false;
      this.selected = [];
      this.selected_receivers = [];
      this.disable = true;
    },
    closeReceiverDialog() {
      this.receiver_dialog = false;
      this.instructions_dialog = false;
      this.selected_receiver = null;
      this.all_receivers = null;
      this.selected = [];
      this.selected_receivers = [];
      this.disable = true;
    },
    openReceiverModal() {
      this.select_update = false;
      this.receiver_dialog = true;
    },
    addInstructions(receiver) {
      this.instructions_dialog = true;
      this.selected_receiver = receiver;
    },
    formatDate(date) {
      return moment(new Date(date)).format('dddd, MMMM DD YYYY');
    },
  },
  computed: {
    ...mapGetters([
      'getAssignedUsers',
      'getUnassignedUsers',
      'allActions',
      'addedReceivers',
      'allUsersByOffice',
    ]),
    modifiedAddedReceivers() {
      let newreceivers = [];
      this.addedReceivers.forEach((receiver) => {
        newreceivers.push(Object.assign({ isSelected: false }, receiver));
      });
      return newreceivers;
    },
  },
  created() {
    this.fetchUsersInOffice();
    this.fetchActions({ bypass: true, limit: 0 });
  },
  watch: {
    showSelect: function() {
      if (this.showSelect == 'Receivers') {
        this.datetime_due = this.initiatorDueDate;
      }
    },
  },
};
</script>

<style scoped>
.selected {
  background-color: #bbb;
}
.user-box {
  overflow: auto;
  overflow-x: hidden;
  height: 300px;
  border-style: solid;
  border-width: thin;
  border-color: #d1d1d1;
}

ul {
  padding: 0px;
  margin-top: 0px;
}

li {
  list-style: none;
  border-bottom: solid;
  border-width: thin;
  padding-bottom: 6px;
  padding-top: 6px;
  cursor: pointer;
}

li:hover {
  background-color: rgb(230, 230, 230);
}</style
>>
